// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pintura_main .cv-header.bx--header{z-index:1;background-color:#fff;border-bottom:none}.pintura_main .cv-header.bx--header .bx--btn--ghost{color:#525252}.pintura_main .cv-header-name.bx--header__name{color:#161616}.pintura_main .cv-header-name.bx--header__name:hover{color:#181818}", ""]);
// Exports
module.exports = exports;
